export enum TitleDataHooks {
  Main = 'title',
  HeaderTitle = 'header-title',
}
